import gql from 'graphql-tag';

const GET_HOLIDAYS = gql`
  query {
    getAllHolidayList {
      id
      name
    }
  }
`;

const GET_HOLIDAY_LIST = gql`
  query($id: ID!, $year: Int!) {
    getHolidayList(id: $id, year: $year) {
      id
      name
      holidays {
        name
        id
        day
        month
      }
      years
    }
  }
`;

const ADD_HOLIDAY_LIST = gql`
  mutation($name: String, $year: Int!, $holidays: [HolidayInput]) {
    addHolidayList(
      year: $year
      input: { name: $name, addHolidays: $holidays }
    ) {
      id
      name
      holidays {
        name
        month
        day
        id
      }
    }
  }
`;

const DELETE_HOLIDAY_LIST = gql`
  mutation($listId: ID!) {
    deleteHolidayList(listId: $listId)
  }
`;

const UPDATE_HOLIDAY_LIST = gql`
  mutation(
    $id: ID!
    $name: String
    $year: Int!
    $addHolidays: [HolidayInput]
    $updateHolidays: [HolidayInput]
    $deleteHolidays: [HolidayInput]
  ) {
    updateHolidayList(
      id: $id
      input: {
        name: $name
        addHolidays: $addHolidays
        updateHolidays: $updateHolidays
        deleteHolidays: $deleteHolidays
      }
      year: $year
    ) {
      id
      name
      holidays {
        name
        month
        day
        id
      }
    }
  }
`;

export {
  ADD_HOLIDAY_LIST,
  GET_HOLIDAYS,
  GET_HOLIDAY_LIST,
  UPDATE_HOLIDAY_LIST,
  DELETE_HOLIDAY_LIST
};
